import React from 'react';
import { useDropzone } from 'react-dropzone';
import * as S from './DropzoneUpload.styles';
import { FolderOpen } from 'lucide-react';

type DropzoneUploadProps = {
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  multiple?: boolean;
  inset?: string;
  onDrop: (_files: File[]) => void;
};

const DropzoneUpload: React.FC<DropzoneUploadProps> = (props) => {
  const { onDrop, className, multiple = false, children, inset, disabled } = props;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    noClick: true,
    multiple,
    disabled,
    onDropAccepted: onDrop,
  });

  return (
    <S.Root {...getRootProps()} isDragActive={isDragActive} className={className}>
      <input type='file' name='attachments' hidden {...getInputProps()} />
      <S.AttachmentDropzone className='attachment-dropzone' {...(inset && { style: { inset } })}>
        <S.VisualAssist>
          <S.IconWrapper>
            <FolderOpen />
          </S.IconWrapper>
          <S.Text>Drop files here to upload them to the audit.</S.Text>
        </S.VisualAssist>
      </S.AttachmentDropzone>
      {children}
    </S.Root>
  );
};

export default DropzoneUpload;
